import { Table } from '@shared/models';

export interface PaystubSummary {
  adjustmentType?: string;
  checkDate?: Date;
  deductionsTotal?: number;
  earningsHoursTotal?: number;
  earningsTotal?: number;
  netPay?: number;
  nextPayDay?: Date;
  periodBeginDate?: Date;
  periodEndDate?: Date;
  postTaxDeductionsTotal?: number;
  postTaxDeductionsYTD?: number;
  preTaxDeductionsTotal?: number;
  preTaxDeductionsYTD?: number;
  taxesTotal?: number;
  ytdEarningsTotal?: number;
  ytdNetPay?: number;
  ytdPostTaxDeductions?: number;
  ytdPreTaxDeductions?: number;
  ytdTaxesTotal?: number;
}

export interface PaystubInfo {
  amount: string;
  checkId: string;
  day: string;
  didId: number;
  isVoided?: boolean;
  isActive?: boolean;
}

export interface PaystubDetailItem {
  amount: number;
  available: number;
  checkId: number;
  code: string;
  currentAmount: number;
  earned: number;
  hour: number;
  isEmployeeTax: boolean;
  isFakeData: boolean;
  itemName: string;
  qtdAmount: number;
  qtdHours: number;
  mtdAmount: number;
  mtdHours: number;
  rate: number;
  taxServiceCode: string;
  shortFallAdjustment: number;
  shortFallBalance: number;
  shortFallTaxCode: string;
  showOnReports: boolean;
  taxabilityCode: string;
  timeOffHours: number;
  type: string;
  used: number;
  ytdAmount: number;
  ytdEarned: number;
  ytdHours: number;
  ytdUsed: number;
}

export interface PaymentInfo {
  amount: number;
  bankAccountNumber?: string;
  calculationMethod?: string;
  transactionType?: string;
}

export interface BenefitsDetail {
  availableHours: string;
  benefitsBalance: number;
  benefitName: string;
  benefitNumber: number;
  earnedHours: string;
  earnedYTDHours: string;
  usedYTDHours: number;
  usedHours: number;
  maximumBalance: string;
}

export interface PaystubDetails {
  benefitsDetail: BenefitsDetail[];
  earningsDetail: PaystubDetailItem[];
  paymentDetails: PaymentInfo[];
  postTaxDeductionsDetail: PaystubDetailItem[];
  preTaxDeductionsDetail: PaystubDetailItem[];
  taxesDetail: PaystubDetailItem[];
}

export interface Paystub {
  details: PaystubDetails;
  summary: PaystubSummary;
}

export interface PaystubDetailsView {
  adjustmentType: string;
  checkDate: string;
  paymentMethod: Table;
  periodEndDate: string;
  periodStartDate: string;
  rightTableCollection: Table[];
  summary: Table;
  timeOff: Table;
}

export interface DashboardRightTable {
  dataRows: string[][];
  headerCells: string[];
  title: string;
}

export interface rawPaystubData {
  paystubDetailCollection: PaystubDetails;
  paystubSummaryCollection: PaystubSummary;
  errorMessage: null;
  success: true;
}

export interface PaystubData {
  paystubDetailCollection: PaystubDetails;
  paystubSummaryCollection: PaystubSummary;
}

export const emptyPaystubData: PaystubData = {
  paystubDetailCollection: {
    benefitsDetail: [],
    earningsDetail: [],
    paymentDetails: [],
    postTaxDeductionsDetail: [],
    preTaxDeductionsDetail: [],
    taxesDetail: [],
  },
  paystubSummaryCollection: {
    adjustmentType: '',
    checkDate: null,
    deductionsTotal: null,
    earningsHoursTotal: null,
    earningsTotal: null,
    netPay: null,
    nextPayDay: null,
    periodBeginDate: null,
  },
};

export interface Check {
  adjustmentType: string;
  bclCode: string;
  checkDate: string;
  checkId: string;
  checkYear: number;
  didId: number;
  e1Id: number;
  netPay: number;
}

export interface rawPaystubsCollection {
  CheckDetails: Check[];
  ErrorMessage: null;
  Success: true;
}
export interface PaystubsCollectionData {
  checks: Check[];
}

export interface PaystubsCollection {
  payInfo: PaystubInfo[];
  title: string;
}

export interface DetailRows {
  earningRows: string[][];
  netPayRows: string[][];
  paymentRows: string[][];
  postTaxRows: string[][];
  preTaxRows: string[][];
  rightTables?: DashboardRightTable[];
  summaryRows: string[][];
  taxRows: string[][];
  timeOffRows: string[][];
}

export interface TotalRows {
  earningTotalRow: string[];
  postTaxTotalRow: string[];
  preTaxTotalRow: string[];
  taxTotalRow: string[];
}

export interface PaystubRows {
  detailRows: DetailRows;
  totalRows: TotalRows;
}
